import React from "react";
import { CheckCircle2, Circle } from "lucide-react";
import { Rich } from "./Rich";

export const NotesToc = ({ topics, active, read, onJump }) => (
  <nav className="space-y-1" data-testid="notes-toc">
    <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-3 px-2">On this page</div>
    {topics.map((t, i) => {
      const isActive = active === t.id;
      return (
        <button
          key={t.id}
          onClick={() => onJump(t.id)}
          className={`w-full text-left flex items-start gap-2 rounded-md px-2 py-1.5 text-sm transition-colors ${isActive ? "bg-white/[0.06] text-yellow-200" : "text-zinc-400 hover:text-zinc-100"}`}
          data-testid={`toc-item-${t.id}`}
        >
          {read.includes(t.id) ? <CheckCircle2 className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" /> : <Circle className="w-4 h-4 mt-0.5 text-zinc-600 shrink-0" />}
          <span><span className="font-mono text-[11px] text-zinc-500 mr-1">{String(i).padStart(2, "0")}</span><Rich>{t.title}</Rich></span>
        </button>
      );
    })}
  </nav>
);

export const NotesTocMobile = ({ topics, active, read, onJump }) => (
  <div className="lg:hidden sticky top-16 z-20 -mx-4 px-4 py-2 bg-[#0b1428]/90 backdrop-blur-md border-b border-white/5 overflow-x-auto flex gap-2" data-testid="notes-toc-mobile">
    {topics.map((t, i) => (
      <button
        key={t.id}
        onClick={() => onJump(t.id)}
        className={`shrink-0 text-xs rounded-full border px-3 py-1 transition-colors ${active === t.id ? "border-yellow-300/60 text-yellow-200" : read.includes(t.id) ? "border-emerald-400/40 text-emerald-300" : "border-white/10 text-zinc-400"}`}
        data-testid={`toc-chip-${t.id}`}
      >
        {String(i).padStart(2, "0")} · <Rich>{t.title}</Rich>
      </button>
    ))}
  </div>
);
